"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.reconcileElementsCreator = reconcileElementsCreator;
var _actions = require("../../actions");
// Alternative to a MutationObserver to detect removal of the form or inputs
function reconcileElementsCreator(getState, dispatch) {
  return () => {
    const {
      formElement
    } = getState();
    if (formElement) {
      if (!document.body.contains(formElement)) {
        dispatch((0, _actions.formUnmount)());
      } else {
        dispatch((0, _actions.reconcileInputs)());
      }
    }
  };
}